import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import BrandReputation from './components/BrandReputation';
import ContactSection from './components/ContactSection';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function AboutPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#contact') {
      setTimeout(() => {
        const el = document.getElementById('contact');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.hash]);

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '久久伊人',
    url: 'https://jiujiuyiren.com',
    description: '久久伊人，专注情感陪伴与品质生活的首选品牌。以真诚与用心守护每一段珍贵关系，让美好情感久久延续。',
    email: 'hello@jiujiuyiren.com',
    telephone: '400-888-9999',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '南京西路1788号久久大厦',
      addressLocality: '上海市',
      addressRegion: '静安区',
      addressCountry: 'CN',
    },
    sameAs: [],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
        />

        <div className="pt-20">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        <AboutHero />
        <BrandStory />
        <BrandReputation />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}